// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.4565 9.67491L15.3144 9.53285C14.6661 8.90784 13.8549 8.43357 12.9235 8.184C10.0168 7.40515 7.22541 9.05261 6.43185 12.0142C6.38901 12.1741 6.36574 12.3536 6.3285 12.805C6.17423 14.6751 5.73449 16.0696 4.5286 17.4841C6.78847 18.3726 9.46572 18.9985 11.5016 18.9985C13.9702 18.9985 16.1644 17.3393 16.8126 14.9201C17.3306 12.9868 16.7513 11.018 15.4565 9.67491ZM13.2886 6.21289L18.2278 2.3713C18.6259 2.06168 19.1922 2.09694 19.5488 2.45355L22.543 5.44775C22.8997 5.80436 22.9349 6.3707 22.6253 6.76879L18.7847 11.7067C19.0778 12.895 19.0836 14.172 18.7444 15.4378C17.8463 18.7896 14.8142 20.9985 11.5016 20.9985C8 20.9985 3.5 19.4966 1 17.9966C4.97978 14.9966 4.04722 13.1864 4.5 11.4966C5.55843 7.54646 9.34224 5.23923 13.2886 6.21289ZM16.7015 8.09149C16.7673 8.15494 16.8319 8.21952 16.8952 8.28521L18.0297 9.41972L20.5046 6.23774L18.7589 4.49198L15.5769 6.96686L16.7015 8.09149Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
